<!--
 * @Author: xiaokun
 * @Date: 2020-04-13 14:49:40
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-23 16:18:42
 * @Description: 试卷审批详情
 -->
<template>
  <div class="examine-approve-detail">
    <create-header
      :title="isApprove ? '试卷审批': '试卷查看'"
      :need-back-txt="isApprove ? true : false"
    />
    <div class="examine-approve-detail-content">
      <left-score-info :is-approve="isApprove" />
      <right-approve-options
        ref="rightApproveOptions"
        :is-approve="isApprove"
      />
    </div>
    <!-- 保存按钮 -->
    <div
      v-if="isApprove"
      class="save-examination"
    >
      <mk-button-biz
        class="save-examination-btn"
        width="96px"
        height="32px"
        @click="handleOnSaveExaminationClick"
      >
        确认保存
      </mk-button-biz>
    </div>
  </div>
</template>
<script>
import createHeader from '@components/create-header'
import LeftScoreInfo from './left-score-info'
import RightApproveOptions from './right-approve-options'
import { mapMutations } from 'vuex'
export default {
  name: 'ExamineApproveDetail',
  components: { LeftScoreInfo, RightApproveOptions, createHeader },
  props: {
    // 是否展示头部 返回
    isPaperExamineApprove: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 保存审批的参数
      params: {}
    }
  },
  computed: {
    isApprove () {
      if (this.$route.query.isApprove) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {},
  // 页面销毁时 初始化 vuex 存储的实时数据
  // destroyed () {
  //   this.initParams()
  // },
  deactivated () {
    this.initParams()
    this.$destroy()
  },
  methods: {
    ...mapMutations('examination-manage', {
      initParams: 'INIT_PARAMS'
    }),
    // 保存审批
    handleOnSaveExaminationClick () {
      let questions = this.$refs.rightApproveOptions.getQuestionList()
      let emptyArr = []
      questions.map((item, index) => {
        if (!item.score && item.score !== 0) {
          emptyArr.push(index + 1)
        }
      })
      if (emptyArr.length > 0) {
        this.$message.error(`当前第${emptyArr.join('、')}道题未打分，请审批`)
        return false
      }
      this.params = {
        paperId: this.$route.query.paperId,
        taskId: this.$route.query.taskId,
        employeeId: this.$route.query.employeeId,
        questions
      }
      this.paperApprovalEmployeePaperPost()
    },
    async paperApprovalEmployeePaperPost () {
      let res = await MBASVCAPIS.PaperApi.paperApprovalEmployeePaperPost(this.params)
      if (res.success) {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.examine-approve-detail {
  position: relative;
  height: 100%;

  /deep/ .border-attribute {
    border-radius: 4px;
    border: 1px solid rgba(232, 232, 232, 1);
  }

  /deep/.el-input-number {
    max-width: 55px;
    line-height: 1;

    .el-input__inner {
      padding: 0;
      margin: 0 5px;
      height: 28px;
      width: 45px;
    }
  }
  // 审批内容
  .examine-approve-detail-content {
    padding: 20px;
    display: flex;
    align-items: flex-start;
  }
  // 保存按钮
  .save-examination {
    background-color: #fff;
    position: absolute;
    bottom: 0;
    text-align: center;
    width: 100%;
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
    padding: 12px 0;

    .save-examination-btn {
      background-color: #009cff;
      color: #fff;
      font-size: 13px;
      font-weight: 400;
      border: 0;
    }
  }
}
</style>
